"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function validateResponse(response) {
    if (response == undefined)
        return Promise.reject("Empty response");
    if (response.code !== 0) {
        return Promise.reject(response.message);
    }
    return Promise.resolve(response);
}
exports.validateResponse = validateResponse;
